let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a1tQm")).then(() => parcelRequire('hW326'));